import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const servicesUrl = `${SERVER_API}/services`;

export default {
  SERVICES: {
    ...generateCrudEndpoints(`${SERVER_API}/services`),
    PUBLISH(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${SERVER_API}/services/status/${id}/publish`,
      };
    },
    CHANGE_STATUS(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${SERVER_API}/services/status/${id}`,
      };
    },
    COPY(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${SERVER_API}/services/${id}/copy`,
      };
    },
    SHOWCASE_GROUPS: {
      method: 'GET',
      url: `${SERVER_API}/public/services/showcase/groups`,
    } as IEndpointData,
    SHOWCASE_DEPARTMENTS: {
      method: 'GET',
      url: `${SERVER_API}/public/services/showcase/departments`,
    } as IEndpointData,
    UPDATE_PUBLISHED(id: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${SERVER_API}/services/published/${id}`,
      };
    },
  },
};
